import React from 'react'

import OrderActions from '../../actions/OrderActions.js'

import dbCodes from '../../../server/dbCodes.js'
import {Alert, Card, Colors, Button, IconButton, Modal, H4, Popup, Link, S1, S2, P, ScrollView, Row, MenuButton, Spinner, Stack} from '../UI/index.js'
import askToSaveChanges from '../UI/overlays/askToSaveChanges.js'
import SelectRoute from '../routes/SelectRoute.js'
import {formSpacing, FormRow, Input, Select} from '../UI/forms/index.js'
import NotSuppliedOrderPopup from './NotSuppliedOrderPopup.js'
import MancoOrderPopup from './MancoOrderPopup.js'
import CancelOrderPopup from './CancelOrderPopup.js'
import AtHubOrderPopup from './AtHubOrderPopup.js'
import RescheduleOrderPopup from './RescheduleOrderPopup.js'
import OnHoldOrderPopup from './OnHoldOrderPopup.js'
import ReturnOrderPopup from './ReturnOrderPopup.js'
import PickupDeliverPopup from './PickupDeliverPopup.js'
import Info from './Info.js'
import Address from './Address.js'
import Collo from './Collo.js'
import Temperature from './Temperature.js'
import SendEmailNotificationPopup from './SendEmailNotificationPopup.js'
import Administration from './Administration.js'
import MoreOptions from './MoreOptions.js'
import moment from 'moment'
import calcDistance from '../../../utils/calcDistance.js'
import {getOriginalAddressColli, isRetourOrder} from '../../../utils/retourAddresses.js'
import {base64ImageToDataUrl} from '../../../utils/imageDataUrl.js'
import externalCarrierNames from '../../../utils/externalCarriers.js'
import Packaging from './Packaging.js'
import {emit} from 'src/socketio/socketEmit.js'
import t from '../../helpers/Languages.js'
import {getAvailableBranches} from 'src/utils/branches.js'

class ViewOrderModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            orderLoading: false,
            orderError: null,
            order: null,
            routeAfterRescheduling: null,
            removeAll: false,
            entryPopup: null,
            entryPopupView: '',
            loading: false,
            historyComment: '',
            branchHover: false,
            editBranch: false,
            branchId: '',
            branchError: '',
            message: '',
            error: ''
        }

        this.state = structuredClone(this.initialState)

        // The sections of the order (addresses, colli, administration, more options) that can be edited, by key
        this.sections = {}
    }

    async fetchRouteIfMissing(order) {
        if (!order?.routeId || this.props.routes?.[order.routeId]) {
            return
        }

        try {
            const {data: route} = await emit('orders.getRoute', order.routeId)
            this.setState({routeAfterRescheduling: route})
        } catch (err) {
            this.setState({error: err instanceof Error ? err.message : String(err)})
        }
    }

    open(id, fromScan) {
        if (typeof id === 'object') {
            const order = id

            console.log(order)

            this.setState({modalIsOpen: true, order, email: order.email})
            this.fetchRouteIfMissing(order)
        } else {
            this.setState({modalIsOpen: true, orderLoading: true})

            OrderActions.getOne(id, (err, order) => {
                if (err) {
                    this.setState({orderLoading: false, orderError: err})
                } else {
                    console.log(order)
                    this.setState({orderLoading: false, orderError: null, order, email: order.email})
                    this.fetchRouteIfMissing(order)
                }
            })
        }
        this.setState({fromScan})
    }

    close() {
        const {fromScan} = this.state
        const {match: {params: {orderId = ''}}, history} = this.props

        typeof fromScan === 'function' && fromScan()

        this.setState(this.initialState)

        if (orderId) {
            history.push('/planning')
        }
    }

    // The save functions of all changes that are not saved yet, each calls back with an error when saving fails
    getUnsavedChanges() {
        const {order, editBranch, branchId, historyComment} = this.state

        const saves = Object.values(this.sections)
            .filter((section) => section?.hasChanges())
            .map((section) => section.saveChanges.bind(section))

        if (editBranch && branchId !== (order?.branchId || '')) {
            saves.push(this.onSaveBranch.bind(this))
        }

        if (historyComment) {
            saves.push(this.onAddHistoryComment.bind(this))
        }

        return saves
    }

    async onClose() {
        const saves = this.getUnsavedChanges()

        if (saves.length === 0) {
            this.close()
            return
        }

        const choice = await askToSaveChanges(this.popup)

        if (choice === 'save') {
            this.saveChangesAndClose(saves)
        } else if (choice === 'dontSave') {
            this.close()
        }
    }

    // Saves one change after the other, as they all update the same order, and keeps the modal open when one fails so its error stays visible
    saveChangesAndClose(saves) {
        const [save, ...rest] = saves

        if (!save) {
            this.close()
            return
        }

        save((err) => {
            if (!err) {
                this.saveChangesAndClose(rest)
            }
        })
    }

    onClickCancelRetour(id) {
        this.popup.open('Annuleer retour', 'De retour wordt geannuleerd, wil je doorgaan?', () => {
            OrderActions.cancelRetour(id, '', (err, order) => {
                if (err) {
                    this.popup.setError(err)
                } else {
                    this.popup.close()

                    if (order) {
                        this.setState({order})
                    } else {
                        this.close()
                    }
                }
            })
        })
    }

    onClickEditBranch() {
        const {order, editBranch} = this.state

        this.setState({editBranch: !editBranch, branchId: order.branchId || '', branchError: ''})
    }

    onSaveBranch(callback) {
        const {order, branchId} = this.state

        OrderActions.editBranch(order._id, branchId, (err, order) => {
            if (err) {
                this.setState({branchError: err})
            } else {
                this.setState({order, editBranch: false, branchHover: false, branchError: ''})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    onClickViewImage(data, event) {
        event.preventDefault()
        const w = window.open('about:blank')
        const image = new Image()
        image.src = data
        setTimeout(() => {
            w.document.write(image.outerHTML)
        }, 0)
    }

    onClickLocation(location, event) {
        event.preventDefault()
        window.open(`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`)
    }

    async onClickOpenImage(entry) {
        if (entry.imageId) {
            OrderActions.getFile(entry.imageId, (err, file) => {
                if (err) {
                    console.error(err)
                    return
                }

                entry.image = base64ImageToDataUrl(file)
                this.setState({entryPopup: entry, entryPopupView: 'image'})
            })
        } else if (entry.imageIds?.length > 0) {
            entry.images = []

            for (const imageId of entry.imageIds) {
                await new Promise((resolve) => {
                    OrderActions.getFile(imageId, (err, file) => {
                        if (err) {
                            console.error(err)
                        } else {
                            entry.images = entry.images || []
                            entry.images.push(base64ImageToDataUrl(file))
                        }
                        resolve()
                    })
                })
            }
            this.setState({entryPopup: entry, entryPopupView: 'images'})
        } else {
            this.setState({entryPopup: entry, entryPopupView: 'image'})
        }
    }

    onClickOpenSignature(entry) {
        if (entry.signatureId) {
            OrderActions.getFile(entry.signatureId, (err, file) => {
                entry.signature = `data:image/png;base64,${file}`

                this.setState({entryPopup: entry, entryPopupView: 'signature'})
            })
        } else {
            this.setState({entryPopup: entry, entryPopupView: 'signature'})
        }
    }

    onAddHistoryComment(callback) {
        const {historyComment, order} = this.state
        this.setState({loading: true})

        OrderActions.addHistoryComment(order._id, historyComment, (err, updatedOrder) => {
            if (err) {
                this.setState({error: err})
            } else {
                this.setState({order: updatedOrder})
            }
            this.setState({loading: false, historyComment: ''})

            typeof callback === 'function' && callback(err)
        })
    }

    response(err, response) {
        if (err) {
            this.setState({loading: false, message: '', error: err})
        } else {
            this.setState({loading: false, message: response, error: ''})
        }
    }

    render() {
        const {modalIsOpen, orderLoading, orderError, order, routeAfterRescheduling, entryPopup, entryPopupView, historyComment, branchHover, editBranch, branchId, branchError, message, error} = this.state
        let {history, reseller, user, usersObject, routes, customers, partners, editOrder, onChangeRoute, onClickCopy, onClickRemove, onClickPrintLabels, addressBook} = this.props

        const statusHistory = order?.history.filter((entry) => typeof entry.status === 'number')

        // A partner's order is executed for the sending partner, its customer can never be changed
        const isPartnerOrder = order?.handledBy === 'reseller' && !!order.partnerId

        // The data of a partner's order that is shared with the partner may only be edited as far as the sending partner allows
        const allowEditOrder = isPartnerOrder ? partners?.[order.partnerId]?.allowEditOrder || 'yes' : 'yes'

        const {statusColor, status, subStatus} = Colors.orderStatusColor(order)

        if (routeAfterRescheduling) {
            routes = {...routes, [routeAfterRescheduling._id]: routeAfterRescheduling}
        }

        return (
            <Modal show={modalIsOpen} onClose={this.onClose.bind(this)}>
                <div style={{position: 'relative'}}>
                    <Row style={{alignItems: 'center', marginBottom: 12}}>
                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                            <H4>{t('orderInfo')}</H4>

                            <div style={{flex: 1}} />
                        </Row>

                        {!orderLoading &&
                            <>
                                <IconButton
                                    tooltip={t('editOrder')}
                                    disabled={statusHistory?.length !== 1 || allowEditOrder !== 'yes'}
                                    onClick={() => {
                                        this.close()
                                        editOrder(order)
                                    }}
                                >
                                    <i className='mdi mdi-pencil' />
                                </IconButton>

                                {/* {order?.templateId &&
                                    <IconButton
                                        tooltip='Bewerk herhaalde rit'
                                        onClick={() => {
                                            this.popup.open('Herhaalde rit bewerken', 'Je gaat deze rit en alle toekomstige ritten aanpassen, weet je zeker dat je door wil gaan?', () => {
                                                OrderActions.getTemplate(order.templateId, (err, template) => {
                                                    if (err) {
                                                        this.setState({error: err})
                                                        return
                                                    }

                                                    this.popup.close()
                                                    this.close()
                                                    editOrder(template, true, order.date)
                                                })
                                            })
                                        }}
                                    >
                                        <i className='mdi mdi-calendar-edit' />
                                    </IconButton>
                                } */}

                                <IconButton
                                    tooltip={t('copyOrder')}
                                    onClick={async () => {
                                        await onClickCopy(order._id)
                                        this.close()
                                    }}
                                >
                                    <i className='mdi mdi-content-copy' />
                                </IconButton>

                                <IconButton
                                    tooltip={t('printLabels')}
                                    onClick={() => onClickPrintLabels(order._id)}
                                >
                                    <i className='mdi mdi-printer' />
                                </IconButton>

                                <IconButton
                                    tooltip={t('removeOrder')}
                                    disabled={statusHistory?.length !== 1 || order.createdByCustomer || ['parcelPickup', 'parcelDelivery', 'retour'].includes(order.type)}
                                    onClick={() => onClickRemove(order)}
                                >
                                    <i className='mdi mdi-delete' />
                                </IconButton>

                                <IconButton
                                    tooltip={t('sendProofOfCompletion')}
                                    disabled={order?.retourId || !order?.history.some((entry) => ['pickup', 'delivery'].includes(entry.type))}
                                    onClick={() => this.sendEmailNotificationPopup.open(order, (order) => this.setState({order}))}
                                >
                                    <i className='mdi mdi-at' />
                                </IconButton>
                            </>
                        }

                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                            <div style={{flex: 1}} />

                            <IconButton onClick={this.onClose.bind(this)}>
                                <i style={{color: Colors.buttonSolid}} className='mdi mdi-close' />
                            </IconButton>
                        </Row>
                    </Row>

                    {orderLoading || !order ?
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 250}}>
                            <Spinner color={Colors.textDark} />
                        </div> :
                        <>
                            {/* The branch is internal to the reseller, so it can be changed whatever the status of the order */}
                            {getAvailableBranches(reseller).length > 0 &&
                                <>
                                    <div
                                        style={{display: 'flex', gap: formSpacing.tight, marginBottom: 12}}
                                        onMouseEnter={() => this.setState({branchHover: true})}
                                        onMouseLeave={() => this.setState({branchHover: false})}
                                    >
                                        <Select
                                            label={t('branch')}
                                            value={editBranch ? branchId : order.branchId || ''}
                                            options={(reseller.settings.branches || []).map((branch) => {
                                                return {value: branch.id, title: branch.name}
                                            })}
                                            allowEmpty
                                            disabled={!editBranch}
                                            onChange={(event) => this.setState({branchId: event.target.value})}
                                        />

                                        <div style={{width: 42, display: 'flex', alignItems: 'center'}}>
                                            {editBranch &&
                                                <IconButton
                                                    tooltip={t('save')}
                                                    icon='mdi mdi-check'
                                                    onClick={() => this.onSaveBranch()}
                                                />
                                            }

                                            {!editBranch && branchHover &&
                                                <IconButton
                                                    tooltip={t('editBranch')}
                                                    icon='mdi mdi-pencil'
                                                    onClick={this.onClickEditBranch.bind(this)}
                                                />
                                            }
                                        </div>
                                    </div>

                                    {branchError &&
                                        <Alert style={{marginBottom: 6}} variant='danger'>{branchError}</Alert>
                                    }
                                </>
                            }

                            <Card style={{marginBottom: 24, padding: 0}}>
                                <Info
                                    customers={customers}
                                    order={order}
                                    sharedReadOnly={allowEditOrder !== 'yes'}
                                    customerReadOnly={isPartnerOrder}
                                    onUpdateOrder={(order) => this.setState({order})}
                                />

                                <Row style={{flexDirection: 'column'}}>
                                    {(order.handledBy === 'partner' || order.handledBy === 'external') &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <P style={{color: Colors.textDark}}>
                                                    {t('orderHandledByCarrier', order.handledBy === 'external' ? externalCarrierNames[order.externalCarrierId] || '' : partners?.[order.carrierId]?.name || '')}

                                                    {order.handledBy === 'external' && order.externalTrackTraceLink &&
                                                        <>
                                                            {' '}
                                                            <a style={{fontWeight: 'bold'}} href={order.externalTrackTraceLink} target='_blank' rel='noopener noreferrer'>{t('viewCarrierTrackTrace')}</a>
                                                        </>
                                                    }
                                                </P>
                                            </Alert>
                                        </Row>
                                    }

                                    {order.type !== 'retour' && order.previousId && !order.retourReseller &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <P style={{color: Colors.textDark}}>Bij deze rit hoort een voorgaande rit. <a style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.open(order.previousId)}>Klik hier</a> om deze te bekijken.</P>
                                            </Alert>
                                        </Row>
                                    }

                                    {/* LEGACY: links between a separate retour order and its original order, remove once no open legacy retour orders are left */}
                                    {order.type === 'retour' && order.previousId && !order.retourId && !order.previousReseller &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <P style={{color: Colors.textDark}}>Dit is een retourrit. <a style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.open(order.previousId)}>Klik hier</a> om de bezorgrit te bekijken.</P>
                                            </Alert>
                                        </Row>
                                    }

                                    {order.type === 'retour' && order.previousId && !order.retourId && order.previousReseller &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <P style={{color: Colors.textDark}}>Dit is een retourrit. De bezorgrit is door een partner uitgevoerd.</P>
                                            </Alert>
                                        </Row>
                                    }

                                    {order.retourId && order.retourId !== order._id && !order.partnerId && !order.retourReseller &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <div style={{display: 'flex'}}>

                                                    <P style={{flex: 1, color: Colors.textDark}}>Voor deze rit is een retourrit aangemaakt. <a style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.open(order.retourId)}>Klik hier</a> om deze te bekijken.</P>

                                                    <P style={{color: Colors.textDark}}>
                                                        <a style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.onClickCancelRetour(order.retourId)}>
                                                            <i className='mdi mdi-close-circle' />
                                                            Annuleer retour
                                                        </a>
                                                    </P>

                                                </div>
                                            </Alert>
                                        </Row>
                                    }

                                    {order.retourId && order.retourReseller &&
                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, marginLeft: 6, marginRight: 6, minWidth: 'auto'}}>
                                            <Alert style={{marginBottom: 6, width: '100%'}} variant='info'>
                                                <div style={{display: 'flex'}}>

                                                    <P style={{flex: 1, color: Colors.textDark}}>{`Voor deze rit is een retourrit aangemaakt. Deze wordt uitgevoerd door ${order.retourReseller}.`}</P>

                                                    <P style={{color: Colors.textDark}}>
                                                        <a style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.onClickCancelRetour(order.retourId)}>
                                                            <i className='mdi mdi-close-circle' />
                                                            Annuleer retour
                                                        </a>
                                                    </P>

                                                </div>
                                            </Alert>
                                        </Row>
                                    }
                                </Row>

                                <FormRow style={{paddingLeft: formSpacing.columnGap, paddingRight: formSpacing.columnGap, marginBottom: formSpacing.rowGap}}>
                                    <SelectRoute
                                        label='Route'
                                        usersObject={usersObject}
                                        routes={routes}
                                        date={order.date}
                                        value={order.routeId}
                                        disabled={order.handledBy == 'partner' || ![dbCodes.status.verwacht(), dbCodes.status.inSortering(), dbCodes.status.gereed(), dbCodes.status.onderweg()].includes(order.status)}
                                        onChange={(event) => {
                                            onChangeRoute(order._id, event, (err, order) => {
                                                if (err) {
                                                    this.setState({error: err})
                                                } else {
                                                    this.setState({order})
                                                }
                                            })
                                        }}
                                    />

                                    <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center', background: statusColor, height: 42}}>
                                        {subStatus && subStatus !== dbCodes.status[dbCodes.status.geannuleerd()] ?
                                            <S1 ellipsis>{`${subStatus}${Colors.orderRetourSuffix(order)}`}</S1> :
                                            <S1 ellipsis>{`${status}${Colors.orderRetourSuffix(order)}`}</S1>
                                        }
                                    </Stack>
                                </FormRow>

                                <FormRow style={{paddingLeft: formSpacing.columnGap, paddingRight: formSpacing.columnGap, marginBottom: formSpacing.tight}}>
                                    <div style={{display: 'flex', flex: 1, columnGap: formSpacing.columnGap}}>
                                        <Button
                                            style={{flex: 1}}
                                            variant='outline'
                                            tooltip='Aangeleverd op hub'
                                            icon='mdi mdi-package-variant-closed-check'
                                            disabled={!order.atHubPossible || order.handledBy !== 'reseller' || (order.retourId && order.retourId !== order._id)}
                                            onClick={() => this.atHubOrderPopup.open(order, (order) => this.setState({order}))}
                                        />

                                        <Button
                                            style={{flex: 1}}
                                            variant='outline'
                                            tooltip='Herplannen'
                                            icon='mdi mdi-calendar'
                                            disabled={!order.reschedulePossible || order.handledBy !== 'reseller' || (order.retourId && order.retourId !== order._id)}
                                            onClick={() => this.rescheduleOrderPopup.open(order, (order) => {
                                                this.setState({order})
                                                this.fetchRouteIfMissing(order)
                                            })}
                                        />

                                        <Button
                                            style={{flex: 1}}
                                            variant='outline'
                                            tooltip='In bewaring'
                                            icon='mdi mdi-archive'
                                            disabled={!order.onHoldPossible || order.handledBy !== 'reseller' || order.templateId || (order.retourId && order.retourId !== order._id) || [dbCodes.status.inBewaring()].includes(order.status) || reseller.isShop}
                                            onClick={() => this.onHoldOrderPopup.open([order._id], (order) => this.setState({order}))}
                                        />

                                        <Button
                                            style={{flex: 1}}
                                            variant='outline'
                                            tooltip='Retour'
                                            icon='mdi mdi-keyboard-return'
                                            disabled={!order.returnPossible || order.type === 'retour' || order.retourId || reseller.isShop}
                                            onClick={() => this.returnOrderPopup.open([order._id], (order) => this.setState({order}))}
                                        />

                                        {order.type !== 'retour' &&
                                            <MenuButton
                                                style={{flex: 1}}
                                                variant='outline'
                                                icon='mdi mdi-close-circle'
                                                disabled={order.retourId || (!order.notSuppliedPossible && !order.mancoPossible && !order.cancelPossible)}
                                                options={[
                                                    {label: 'Niet aangeleverd', disabled: !order.notSuppliedPossible || order.handledBy !== 'reseller', onClick: () => this.notSuppliedOrderPopup.open(order, (order) => this.setState({order}))},
                                                    {label: 'Manco', disabled: !order.mancoPossible || order.handledBy !== 'reseller', onClick: () => this.mancoOrderPopup.open(order, (order) => this.setState({order}))},
                                                    {label: 'Annuleren', disabled: !order.cancelPossible, onClick: () => this.cancelOrderPopup.open(order, (order) => this.setState({order}))}
                                                ]}
                                            />
                                        }

                                        {order.type === 'retour' &&
                                            <Button
                                                style={{flex: 1}}
                                                variant='outline'
                                                tooltip='Annuleren'
                                                icon='mdi mdi-close-circle'
                                                disabled={[dbCodes.status.afgerond()].includes(order.status)}
                                                onClick={this.onClickCancelRetour.bind(this, order._id)}
                                            />
                                        }
                                    </div>

                                    <Button
                                        style={{flex: 1}}
                                        variant='outline'
                                        label='Ophalen / Bezorgen'
                                        disabled={order.handledBy !== 'reseller' || order.colli.every((collo) => collo.status === 'expected') || [dbCodes.status.geannuleerd()].includes(order.status)}
                                        onClick={() => this.pickupDeliverPopup.open(order, reseller, customers?.[order.customer], (order) => this.setState({order}))}
                                    />
                                </FormRow>
                            </Card>

                            <S1 style={{marginBottom: 12}}>Adressen</S1>

                            <div style={{width: '100%', marginBottom: 24}}>
                                {isRetourOrder(order) && order.originalAddresses?.map((address, addressIndex) => {
                                    // The status the original address ended with, its colli now belong to the retour address
                                    const originalColli = getOriginalAddressColli(order, address)
                                    const originalOrder = {...order, colli: []}
                                    originalColli.forEach((collo) => originalOrder.colli[collo.index] = collo)

                                    return (
                                        <div key={`originalAddress${addressIndex}`}>
                                            <Address
                                                reseller={reseller}
                                                order={order}
                                                address={address}
                                                disabled
                                            />

                                            {originalColli.length > 0 &&
                                                <Card style={{marginTop: -13, marginBottom: 24, padding: 0, background: Colors.backgroundNeutral2, opacity: 0.7}}>
                                                    {originalColli.map((collo, index) => {
                                                        return (
                                                            <Collo
                                                                key={`OriginalCollo${collo.index}`}
                                                                index={index}
                                                                colli={originalColli}
                                                                order={originalOrder}
                                                                addressIndex={address.index}
                                                                addressType={address.type}
                                                                colloIndex={collo.index}
                                                                disabled={['cancelled'].includes(collo.status)}
                                                                readOnly
                                                                reseller={reseller}
                                                                customer={customers[order.customer]}
                                                            />
                                                        )
                                                    })}
                                                </Card>
                                            }
                                        </div>
                                    )
                                })}

                                {order.addresses.map((address, addressIndex) => {
                                    const addressColli = order.colli.filter((collo) => (address.type === 'pickup' && collo.pickupAddressIndex === address.index) || (address.type === 'delivery' && collo.deliveryAddressIndex === address.index))

                                    return (
                                        <div key={`address${addressIndex}`}>
                                            <Address
                                                key={`address${addressIndex}`}
                                                ref={(ref) => this.sections[`address${addressIndex}`] = ref}
                                                reseller={reseller}
                                                order={order}
                                                addressIndex={addressIndex}
                                                addressBook={addressBook}
                                                isRetour={isRetourOrder(order)}
                                                readOnly={allowEditOrder === 'no'}
                                                onUpdateOrder={(order) => this.setState({order})}
                                                onClickPrintLabels={onClickPrintLabels}
                                            />

                                            {addressColli.length > 0 &&
                                                <Card style={{marginTop: -13, marginBottom: 24, padding: 0}}>
                                                    {addressColli.map((collo, index) => {
                                                        return (
                                                            <Collo
                                                                key={`Collo${collo.index}`}
                                                                ref={(ref) => this.sections[`collo${addressIndex}-${collo.index}`] = ref}
                                                                index={index}
                                                                colli={addressColli}
                                                                order={order}
                                                                addressIndex={addressIndex}
                                                                addressType={address.type}
                                                                colloIndex={collo.index}
                                                                onUpdateOrder={(order) => this.setState({order})}
                                                                onClickPrintLabels={address.type === 'delivery' && onClickPrintLabels}
                                                                disabled={['cancelled'].includes(collo.status)}
                                                                readOnly={allowEditOrder === 'no'}
                                                                reseller={reseller}
                                                                customer={customers[order.customer]}
                                                            />
                                                        )
                                                    })}
                                                </Card>
                                            }
                                        </div>
                                    )
                                })}
                            </div>

                            {order.packages?.length > 0 &&
                                <>
                                    <S1 style={{marginBottom: 12}}>Emballage</S1>

                                    <Card style={{marginBottom: 24, padding: 0}}>
                                        {order.packages.map((packaging, index) => {
                                            return (
                                                <Packaging
                                                    key={`Packaging${index}`}
                                                    history={history}
                                                    index={index}
                                                    order={order}
                                                    packaging={packaging}
                                                />
                                            )
                                        })}
                                    </Card>
                                </>
                            }

                            {order.monitorTemperature && order.temperatureData && !!order.temperatureData.length &&
                                <>
                                    <S1 style={{marginBottom: 12}}>Temperatuur</S1>
                                    <Temperature reseller={reseller} order={order} />
                                </>
                            }

                            <Administration
                                ref={(ref) => this.sections.administration = ref}
                                reseller={reseller}
                                customer={customers?.[order.customer]}
                                order={order}
                                onUpdateOrder={(order) => this.setState({order})}
                            />

                            <MoreOptions
                                ref={(ref) => this.sections.moreOptions = ref}
                                reseller={reseller}
                                order={order}
                                sharedReadOnly={allowEditOrder !== 'yes'}
                                onUpdateOrder={(order) => this.setState({order})}
                            />

                            <S1 style={{marginBottom: 12}}>Historie</S1>

                            <FormRow gap={formSpacing.tight} style={{marginBottom: formSpacing.rowGap}}>
                                <Input
                                    label='Opmerking toevoegen'
                                    value={historyComment}
                                    style={{width: 400}}
                                    onChange={(event) => this.setState({historyComment: event.target.value})}
                                    onKeyUp={(event) => {
                                        if (event.key === 'Enter' && historyComment) {
                                            this.onAddHistoryComment()
                                        }
                                    }}
                                />

                                <IconButton
                                    icon='mdi mdi-check'
                                    onClick={() => this.onAddHistoryComment()}
                                    disabled={!historyComment}
                                />
                            </FormRow>

                            <ScrollView style={{maxHeight: 250}}>
                                {[...order.history].reverse().map((entry, index) => {
                                    let deviationMeters

                                    if (entry.location?.lat && order.addresses[entry.addressIndex]?.position?.lat) {
                                        deviationMeters = parseInt(calcDistance(entry.location, order.addresses[entry.addressIndex].position)) - parseInt(entry.location.accuracy)
                                    }

                                    if (entry.type === 'invoice' && !user.permissions.invoices) {
                                        return
                                    }

                                    return (
                                        <Row key={`history${index}`} style={{marginBottom: 3, flexShrink: 0}}>

                                            <i className='mdi mdi-circle-small' style={{marginRight: 6, fontSize: 16, color: Colors.grey60}} />

                                            <Row style={{paddingLeft: 6, paddingRight: 6, flex: 1, flexDirection: 'column', minWidth: 'auto'}}>

                                                <Row style={{alignItems: 'center'}}>
                                                    {entry.type === 'invoice' ?
                                                        <Link onClick={() => history.push('/facturatie', {invoiceId: entry.invoiceId})}>{entry.description}</Link> :
                                                        <P>{entry.description || (typeof entry.status === 'number' ? dbCodes.status[entry.status] : '')}</P>
                                                    }
                                                </Row>

                                                {entry.colli?.length > 0 &&
                                                    <>
                                                        {entry.colli.map((collo, index) => {
                                                            const {status, reason, statusColor} = Colors.colloStatusColor(entry.type, collo)
                                                            const isScanned = entry?.scanned?.findIndex((barcode) => barcode === collo.barcode) > -1

                                                            return (
                                                                <Row key={`collo${index}`}>
                                                                    <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                                                        <i className='mdi mdi-circle' style={{marginRight: 12, marginTop: 4, fontSize: 10, color: statusColor}} />
                                                                        {isScanned && <i className='mdi mdi-barcode-scan ' style={{marginRight: 6}} />}
                                                                        <P>{`${reason || status}${collo.reasonSpecification ? ` - ${collo.reasonSpecification}` : ''}: Collo ${collo.index + 1}${collo.barcode ? ` - ${collo.barcode}` : ''}`}</P>
                                                                    </Row>
                                                                </Row>
                                                            )
                                                        })}
                                                    </>
                                                }

                                                {entry.comment &&
                                                    <S2 style={{whiteSpace: 'pre'}}>{entry.comment}</S2>
                                                }
                                            </Row>

                                            <Row style={{paddingLeft: 6, paddingRight: 6, width: 180, marginTop: -10, minWidth: 'auto'}}>
                                                {order.addresses[entry.addressIndex]?.position &&
                                                    <IconButton onClick={() => this.setState({entryPopup: entry, entryPopupView: 'location'})} style={{color: !entry.location ? Colors.grey60 : (reseller.settings.deliveryRadiusWarning && deviationMeters >= (reseller.settings.maxDeliveryRadius || 40)) ? Colors.errorBright : Colors.buttonSolid}}>
                                                        <i className='mdi mdi-map-marker-radius' />
                                                    </IconButton>
                                                }

                                                {(entry.signee || entry.signature || entry.signatureId) &&
                                                    <IconButton onClick={() => this.onClickOpenSignature(entry)}>
                                                        {(entry.signature || entry.signatureId) ?
                                                            <i className='mdi mdi-fountain-pen-tip' /> :
                                                            <i className='mdi mdi-signature-text' />
                                                        }
                                                    </IconButton>
                                                }

                                                {entry.documentId &&
                                                    <IconButton onClick={() => this.setState({entryPopup: entry, entryPopupView: 'documentId'})}>
                                                        <i className='mdi mdi-card-account-details-outline' />
                                                    </IconButton>
                                                }

                                                {entry.verificationCode &&
                                                    <IconButton onClick={() => this.setState({entryPopup: entry, entryPopupView: 'verificationCode'})}>
                                                        <i className='mdi mdi-shield-key-outline' />
                                                    </IconButton>
                                                }

                                                {(entry.image || entry.imageId || entry.imageIds?.length > 0) &&
                                                    <IconButton onClick={() => this.onClickOpenImage(entry)}>
                                                        <i className='mdi mdi-image-outline' />
                                                    </IconButton>
                                                }
                                            </Row>

                                            <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                                <S2>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : entry.time}`}</S2>
                                            </Row>
                                        </Row>
                                    )
                                })}
                            </ScrollView>
                        </>
                    }

                    {message &&
                        <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                    }
                    {error &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                    }

                    {orderError &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{orderError}</Alert>
                    }

                    {entryPopup && (
                        <Card style={{position: 'absolute', bottom: -12, left: 800, width: 400, overflowY: 'auto', padding: '12px 12px 24px 12px', background: Colors.backgroundNeutral}}>
                            <Row style={{alignItems: 'center'}}>
                                <H4>
                                    {entryPopupView === 'location' && 'Locatie'}
                                    {entryPopupView === 'signature' && 'Handtekening'}
                                    {entryPopupView === 'documentId' && 'Document ID (laatste 4 tekens)'}
                                    {entryPopupView === 'verificationCode' && 'Verificatiecode'}
                                    {entryPopupView === 'image' && 'Foto'}
                                </H4>

                                <div style={{flex: 1}} />

                                <IconButton onClick={() => this.setState({entryPopup: '', entryPopupView: ''})}>
                                    <i style={{color: Colors.buttonSolid}} className='mdi mdi-close' />
                                </IconButton>
                            </Row>

                            <Row style={{marginTop: 24, marginBottom: 24}}>

                                <i className='mdi mdi-circle' style={{marginRight: 6, marginTop: 3, fontSize: 12, color: Colors.addressColliStatus(order, order.addresses[entryPopup.addressIndex], entryPopup.colli).statusColor || Colors.grey40}} />

                                <Row style={{paddingLeft: 6, paddingRight: 6, flex: 1, flexDirection: 'column', minWidth: 'auto'}}>

                                    <Row style={{alignItems: 'center'}}>
                                        {entryPopup.type === 'invoice' ?
                                            <Link onClick={() => history.push('/facturatie', {invoiceId: entryPopup.invoiceId})}>{entryPopup.description}</Link> :
                                            <P>{entryPopup.description || (typeof entryPopup.status === 'number' ? dbCodes.status[entryPopup.status] : '')}</P>
                                        }
                                    </Row>

                                </Row>

                                <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                    <S2>{`${entryPopup.who} | ${entryPopup.timestamp ? moment(entryPopup.timestamp).format('DD-MM-YYYY HH:mm:ss') : entryPopup.time}`}</S2>
                                </Row>

                            </Row>

                            {entryPopupView === 'location' && (
                                <>
                                    {entryPopup.location ?
                                        <>
                                            <S1>Afwijking met adres</S1>
                                            <P>{parseInt(calcDistance(entryPopup.location, order.addresses[entryPopup.addressIndex].position))} m ±{parseInt(entryPopup.location.accuracy)} m</P>

                                            <br />
                                            <Button
                                                variant='text'
                                                onClick={this.onClickLocation.bind(this, entryPopup.location)}
                                            >
                                                Bekijk op kaart
                                            </Button>
                                        </> :
                                        <P>Locatie is niet beschikbaar</P>
                                    }
                                </>
                            )}

                            {entryPopupView === 'signature' && (
                                <>
                                    {entryPopup?.signee &&
                                        <>
                                            <S1>Getekend door</S1>
                                            <P>{entryPopup?.signee}</P>
                                        </>
                                    }

                                    {entryPopup?.signature &&
                                        <>
                                            <img
                                                style={{height: 200, width: 200, marginRight: 12, objectFit: 'contain'}}
                                                src={entryPopup?.signature}
                                            />
                                            <IconButton onClick={this.onClickViewImage.bind(this, entryPopup?.signature)}>
                                                <i className='mdi mdi-magnify-plus-outline' />
                                            </IconButton>
                                        </>
                                    }
                                </>
                            )}

                            {entryPopupView === 'documentId' && (
                                <Row style={{alignItems: 'center'}}>
                                    <i style={{marginRight: 6}} className='mdi mdi-card-account-details-outline' />
                                    <P>{entryPopup.documentId}</P>
                                </Row>
                            )}

                            {entryPopupView === 'verificationCode' && (
                                <Row style={{alignItems: 'center'}}>
                                    <i style={{marginRight: 6}} className='mdi mdi-shield-key-outline' />
                                    <P>{entryPopup.verificationCode}</P>
                                </Row>
                            )}

                            {entryPopupView === 'image' && (
                                <>
                                    <img
                                        style={{height: 200, width: '100%', objectFit: 'contain'}}
                                        src={entryPopup.image}
                                    />
                                    <IconButton onClick={this.onClickViewImage.bind(this, entryPopup.image)}>
                                        <i className='mdi mdi-magnify-plus-outline' />
                                    </IconButton>
                                </>
                            )}

                            {entryPopupView === 'images' && (
                                <>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 10}}>
                                        {entryPopup.images.map((image, index) => {
                                            return (
                                                <div key={index}>
                                                    <img
                                                        style={{height: 100, width: 120, objectFit: 'contain'}}
                                                        src={image}
                                                    />
                                                    <IconButton onClick={this.onClickViewImage.bind(this, image)}>
                                                        <i className='mdi mdi-magnify-plus-outline' />
                                                    </IconButton>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </>
                            )}
                        </Card>
                    )}
                </div>

                <NotSuppliedOrderPopup reseller={reseller} ref={(ref) => this.notSuppliedOrderPopup = ref} />
                <MancoOrderPopup reseller={reseller} ref={(ref) => this.mancoOrderPopup = ref} />
                <CancelOrderPopup reseller={reseller} ref={(ref) => this.cancelOrderPopup = ref} />
                <AtHubOrderPopup reseller={reseller} ref={(ref) => this.atHubOrderPopup = ref} />
                <RescheduleOrderPopup ref={(ref) => this.rescheduleOrderPopup = ref} />
                <ReturnOrderPopup ref={(ref) => this.returnOrderPopup = ref} />
                <OnHoldOrderPopup ref={(ref) => this.onHoldOrderPopup = ref} />
                <PickupDeliverPopup reseller={reseller} ref={(ref) => this.pickupDeliverPopup = ref} />
                <SendEmailNotificationPopup ref={(ref) => this.sendEmailNotificationPopup = ref} />
                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}

export default ViewOrderModal
